module.exports = __webpack_public_path__ + "static/media/card-content-link.30780de2.svg";